import React from "react";
import PropTypes from "prop-types";

import { affordances } from "../../../../util/analytics";
import ContentHeaderPdfFilesWrapper from "../../../ContentHeaderPdfFilesWrapper";
import ContentHeaderOtherLanguagesWrapper from "../../../ContentHeaderOtherLanguagesWrapper";
import ContentHeaderAdditionalData from "../../../ContentHeaderAdditionalData";
import CheckInteractionsButton from "../../../CheckInteractionsButton";
import CrossContentReferenceLinkContainer from "../../../CrossContentReferenceLinkContainer";
import {
  StyledHowToSayItWrapper,
  StyledAdditionalDataParentWrapper,
  StyledAdditionalDataWrapper,
  StyledHowToSayItLabel,
} from "./_.styled";

const isEventValid = (event) =>
  !!(event?.eventName && event.eventProps && event.label && event.icon?.glyph);

const AdditionalItems = ({
  drugInteractionEvent,
  howToSayIt,
  isDesktop,
  isMobile,
  isPreviewMode,
  telemetryData,
  prettyPubtype,
  pdfFiles,
  crossContentReferenceLinks,
  openWithCloudinaryToken,
  otherLanguages,
  classes,
  routes,
}) => {
  const isDrugInteractionEventValid = isEventValid(drugInteractionEvent);
  const shouldShowHowToSay = !!(howToSayIt?.label && howToSayIt?.value);
  const howToSayTestId = howToSayIt?.testId || "how-to-say-it";

  const renderInteractionsButton = () =>
    isDrugInteractionEventValid && (
      <CheckInteractionsButton
        isDesktop={isDesktop}
        drugInteractionEvent={drugInteractionEvent}
        telemetryData={{
          ...telemetryData,
          affordance: affordances.DRUG_MONOGRAPH,
          pubType: prettyPubtype,
        }}
        testId={
          isMobile
            ? "check-interactions-button-mobile"
            : "check-interactions-button"
        }
        isPreviewMode={isPreviewMode}
      />
    );

  return (
    <>
      {shouldShowHowToSay && (
        <StyledHowToSayItWrapper data-testid={howToSayTestId}>
          <StyledHowToSayItLabel>{howToSayIt.label}</StyledHowToSayItLabel>
          <div dangerouslySetInnerHTML={{ __html: howToSayIt.value }} />
        </StyledHowToSayItWrapper>
      )}

      {!!pdfFiles?.length ? (
        <ContentHeaderPdfFilesWrapper
          pdfFiles={pdfFiles}
          telemetryData={telemetryData}
          handleOpenPdf={openWithCloudinaryToken}
        />
      ) : (
        otherLanguages?.languageList && (
          <ContentHeaderOtherLanguagesWrapper {...otherLanguages} />
        )
      )}

      <StyledAdditionalDataParentWrapper>
        <StyledAdditionalDataWrapper>
          {classes?.value && <ContentHeaderAdditionalData {...classes} />}
          {routes?.value && <ContentHeaderAdditionalData {...routes} />}
          {crossContentReferenceLinks?.length && (
            <CrossContentReferenceLinkContainer
              links={crossContentReferenceLinks}
              telemetryData={{
                ...telemetryData,
                affordance: affordances.HEADER,
                pubType: prettyPubtype,
              }}
            />
          )}
        </StyledAdditionalDataWrapper>
        {!isMobile && renderInteractionsButton()}
      </StyledAdditionalDataParentWrapper>
      {isMobile && renderInteractionsButton()}
    </>
  );
};

AdditionalItems.propTypes = {
  drugInteractionEvent: PropTypes.shape({
    eventName: PropTypes.string,
    eventProps: PropTypes.object,
    label: PropTypes.string,
    icon: PropTypes.shape({
      glyph: PropTypes.string,
    }),
  }),
  howToSayIt: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    testId: PropTypes.string,
  }),
  isDesktop: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isPreviewMode: PropTypes.bool.isRequired,
  telemetryData: PropTypes.object,
  prettyPubtype: PropTypes.string,
  pdfFiles: PropTypes.array,
  crossContentReferenceLinks: PropTypes.arrayOf(PropTypes.object),
  openWithCloudinaryToken: PropTypes.func.isRequired,
  otherLanguages: PropTypes.shape({
    languageList: PropTypes.array.isRequired,
  }),
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    testId: PropTypes.string,
  }),
  routes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    testId: PropTypes.string,
  }),
};

AdditionalItems.displayName = "AdditionalItems";
export default AdditionalItems;
